import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import {
  makeStyles,
  Box,
  Grid,
  Typography,
  Divider,
  IconButton,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteIcon from '@material-ui/icons/Delete';

import FilePickerDialog from './filePickerDialog';
import FileViewerDialog from './fileViewerDialog';

const useStyles = makeStyles((theme) => ({
  image: {
    width: '100px',
    height: '56px',
    objectFit: 'contain',
  },
  imagePlaceholder: {
    //border: '1px solid #ccc',
    height: '56px',
    width: '100px',
  },
  flexRight: {
    marginLeft: 'auto',
  },
  fieldName: {
    flex: 1,
    minWidth: 0,
  },
  fileName: {
    color: 'rgba(0, 0, 0, 0.38)',
    fontSize: '11px',
    display: 'block',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  }
}));

const FilePicker = (props) => {
  const [ pickerOpen, setPickerOpen ] = useState(false);
  const [ viewerOpen, seViewerOpen ] = useState(false);
  const classes = useStyles();
  const { t } = useTranslation();

  const {
    viewOnly = false,
    rootFolderId,
    disabled,
    setFieldValue,
    fieldValue,
    fieldName,
  } = props;

  const handleSelect = file => {
    if(!disabled) {
      setFieldValue(file);
      setPickerOpen(false);
    }
  }

  const handleDelete = () => {
    if(!disabled) {
      setFieldValue('');
    }
  }

  const openInNewWindow = fieldValue?.type === 'pdf';

  return (
    <Box mb={2}>
      <Grid container spacing={2}>
        <Grid item>
          {fieldValue ? <img src={fieldValue.thumbnail} alt="" className={classes.image} /> : <div className={classes.imagePlaceholder}></div>}
        </Grid>
        <Grid item className={classes.fieldName}>
          <Typography variant="subtitle1" component="span">{fieldName}</Typography><br />
          <span className={classes.fileName} title={fieldValue?.name}>{fieldValue?.name}</span>
        </Grid>
        <Grid item className={classes.flexRight}>
          {openInNewWindow
            ?
            <IconButton component="a" href={fieldValue.url} target="_blank" aria-label={t('filePicker:viewLarger')} title={t('filePicker:viewLarger')} color="primary" disabled={!fieldValue}>
              <VisibilityIcon />
            </IconButton>
            :
            <IconButton aria-label={t('filePicker:viewLarger')} title={t('filePicker:viewLarger')} color="primary" onClick={() => seViewerOpen(true)} disabled={!fieldValue}>
              <VisibilityIcon />
            </IconButton>
          }
          {viewOnly
            ? null
            :
            <IconButton aria-label={t('filePicker:change')} title={t('filePicker:change')} color="primary" onClick={() => setPickerOpen(true)} disabled={disabled}>
              <EditIcon />
            </IconButton>
          }
          {viewOnly
            ? null
            :
            <IconButton aria-label={t('filePicker:remove')} title={t('filePicker:remove')} color="primary" onClick={() => handleDelete()} disabled={disabled || !fieldValue}>
              <DeleteIcon />
            </IconButton>
          }
        </Grid>
      </Grid>
      <Divider />
      {viewOnly ? null : <FilePickerDialog open={pickerOpen} title={fieldName} handleSelect={handleSelect} handleClose={() => setPickerOpen(false)} rootFolderId={rootFolderId} selectedFiles={fieldValue ? [fieldValue] : []} /> }
      <FileViewerDialog open={viewerOpen} title={fieldName} file={fieldValue} handleClose={() => seViewerOpen(false)} />
    </Box>
  );
};

FilePicker.propTypes = {
  fieldName: PropTypes.string,
  fieldValue: PropTypes.oneOfType([
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      thumbnail: PropTypes.string,
      medium: PropTypes.string,
      type: PropTypes.string,
      video: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
    }),
    PropTypes.bool
  ]),
  setFieldValue: PropTypes.func,
  disabled: PropTypes.bool,
  rootFolderId: PropTypes.string,
  viewOnly: PropTypes.bool, // Used only as file viewer without edit options
}

export default FilePicker;
